function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import tokens from '@veneer/tokens';
import { system as defaultSystem } from '@veneer/system';
import defaultTheme from '../default_theme';
function getSupportedMode(mode) {
  return mode === 'contrast' ? 'highContrast' : mode;
}
function getDefaultMode(mode) {
  switch (mode) {
    case 'light':
    case 'dark':
      return mode;
    case 'contrast':
      return 'highContrast';
    default:
      return 'light';
  }
}
export default function createTheme(_ref) {
  var _customSystem$level, _customSystem$palette;
  var {
    density = 'standard',
    mode = 'light',
    outerTheme = {},
    shape = 'round',
    customSystem
  } = _ref;
  var supportedMode = getSupportedMode(mode);
  var defaultMode = getDefaultMode(mode);
  var level = (customSystem === null || customSystem === void 0 ? void 0 : (_customSystem$level = customSystem.level) === null || _customSystem$level === void 0 ? void 0 : _customSystem$level[supportedMode]) || defaultSystem.level[defaultMode];
  var palette = (customSystem === null || customSystem === void 0 ? void 0 : (_customSystem$palette = customSystem.palette) === null || _customSystem$palette === void 0 ? void 0 : _customSystem$palette[supportedMode]) || defaultSystem.palette[defaultMode];
  var densityVars = defaultTheme.density[density];
  var shapeVars = defaultTheme.shape[shape] || {};
  if (Object.keys(outerTheme).length > 0) {
    densityVars = _extends({}, densityVars, outerTheme.density ? outerTheme.density[density] : {});
    shapeVars = _extends({}, shapeVars, outerTheme.shape ? outerTheme.shape[shape] : {});
  }
  return _extends({
    density,
    elevation: defaultTheme.elevation,
    level,
    mode,
    palette,
    shape
  }, tokens, densityVars, shapeVars);
}